import { IconContent } from '@icons';

export const censusFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M5 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7.341A6 6 0 0 0 12.528 21H6a1 1 0 0 1-1-1V4Zm14.453 16.16a4 4 0 1 1 .707-.707l3.194 3.194-.708.707-3.193-3.194ZM20 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM16 6H8v1h8V6Zm0 2H8v1h8V8Zm-8 2h5v1H8v-1Z" />',
};
